import Cookies, { CookieGetOptions, CookieSetOptions } from 'universal-cookie';

import { CookieKey } from './cookies-keys';

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '::1';

const defaultSetOptions: CookieSetOptions = {
  path: '/',
  secure: !isLocalhost,
  expires: new Date('2048-01-01T00:00:00.000Z'),
};

const defaultRemoveOptions: CookieSetOptions = {
  path: '/',
};

const cookies = new Cookies(null);

export const cookieUtils = {
  get(key: CookieKey, options?: CookieGetOptions) {
    return cookies.get(key, options);
  },

  set(key: CookieKey, value: string, options?: CookieSetOptions) {
    cookies.set(key, value, { ...defaultSetOptions, ...options });
  },

  remove(key: CookieKey, options?: CookieSetOptions) {
    cookies.remove(key, { ...defaultRemoveOptions, ...options });
  },

  getAll(options: CookieGetOptions) {
    return cookies.getAll(options);
  },
};
